import { jsx as _jsx } from "react/jsx-runtime";
import { Command, useCommandState } from "@air/cmdk";
import { memo, useCallback } from "react";
import { SearchCommandGroup } from "~/components/SearchCommand/SearchCommandGroup";
import { SearchCommandSuggestionListItem } from "~/components/SearchCommand/SearchCommandSuggestionListItem";
export const SmartSearchCommandList = /*#__PURE__*/ memo((param)=>{
    let { onSelect } = param;
    const search = useCommandState((state)=>state.search);
    const onSelectSearch = useCallback(()=>{
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(search);
    }, [
        onSelect,
        search
    ]);
    if (!search) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "grow overflow-y-auto rounded-8 border border-grey-6 bg-grey-1",
        children: /*#__PURE__*/ _jsx(Command.List, {
            className: "flex flex-col gap-0 px-4 py-3",
            "data-testid": "SEARCH_COMMAND_LIST",
            children: /*#__PURE__*/ _jsx(SearchCommandGroup, {
                heading: search ? undefined : "Search suggestions",
                children: /*#__PURE__*/ _jsx(SearchCommandSuggestionListItem, {
                    suggestion: search,
                    onSelect: onSelectSearch
                })
            })
        })
    });
});
SmartSearchCommandList.displayName = "SmartSearchCommandList";
